import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

export function HttpLoaderFactory(http: HttpClient) {
  const randomNr = Math.floor(Math.random() * 100000);
  return new TranslateHttpLoader(http, '/assets/i18n/', `.json?v=${randomNr}`);
}
